<template>
  <div class="cf-node-properties__field">
    <i
      v-if="closeTimeWarning"
      v-tooltip.top="$t('CONCURRENCY_SCHEDULE_WARNING_TT')"
      class="cf-node-properties__hours-filter-day-warning fa fa-exclamation-circle"
      aria-hidden="true"
    />
    <label><strong>{{ day }}</strong></label>
    <nzToggle
      v-if="hoursType == 'advanced'"
      v-model="isOpenStatus"
      @onToggle="updateOpenStatus"
    />
    <div class="cf-node-properties__input">
      <input
        type="time"
        class="form-control"
        step="300"
        aria-label="Open Time"
        :value="openTime"
        :disabled="disabled"
        @change="updateOpenTime($event.target.value)"
      >
    </div>
    <div class="cf-node-properties__input">
      <input
        type="time"
        class="form-control"
        step="300"
        aria-label="Close Time"
        :value="closeTime"
        :disabled="disabled"
        @change="updateCloseTime($event.target.value)"
      >
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import messages from '../../../../locales';
import sharedMessages from '@/core/locales';
import nzToggle from '@/core/components/nzToggle/nzToggle';

export default {
  name: 'HoursFilterTimeValues',
  components: {
    nzToggle
  },
  props: {
    hoursType: {
      type: String,
      default: 'basic'
    },
    openTime: {
      type: String,
      default: '12:00'
    },
    closeTime: {
      type: String,
      default: '24:00'
    },
    day: {
      type: String,
      default: 'Sun - Sat'
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenStatus: this.isOpen
    };
  },
  computed: {
    closeTimeWarning() {
      const openTime = moment(this.openTime, 'HH:mm');
      const closeTime = moment(this.closeTime, 'HH:mm');
      return openTime.isAfter(closeTime);
    }
  },
  methods: {
    updateOpenTime(value) {
      this.$emit('update:open-time', value);
    },
    updateCloseTime(value) {
      this.$emit('update:close-time', value);
    },
    updateOpenStatus(value) {
      this.$emit('update:is-open', value);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>
<style lang='scss' scoped>
.nz-toggle-wrap {
  width: 40px !important;
  height: 20px !important;
  flex: unset;
}
</style>